import { IconName } from '@billy/design-system'
import { TFunction } from 'i18next'

import { VoidStaticActionButton } from '../elements/VoidStaticActionButton/voidStaticActionButton'
import { BillsTableStaticActionType } from '../enums/billsTableStaticActionType'
import { BillsTableStaticActionItem } from '../types/billsTableStaticActionItem'

interface GetBillsTableStaticActionsProps {
  editBillUrl: string
  duplicateBillUrl: string
  createCreditNoteUrl: string
  canRegisterPayment: boolean
  hasIntegrationSync: boolean
  isCashBasedAndPaid: boolean
  isDraft: boolean
  isSyncRetryable: boolean
  t: TFunction
}

export const getBillsTableStaticActions = ({
  editBillUrl,
  duplicateBillUrl,
  createCreditNoteUrl,
  canRegisterPayment,
  hasIntegrationSync,
  isCashBasedAndPaid,
  isDraft,
  isSyncRetryable,
  t,
}: GetBillsTableStaticActionsProps) => {
  const items: BillsTableStaticActionItem[] = [
    {
      children: t('bills.table.static_actions.edit'),
      iconLeft: 'squarePen' as IconName,
      id: BillsTableStaticActionType.Edit,
      value: BillsTableStaticActionType.Edit,
      to: editBillUrl,
    },
    {
      children: t('bills.table.static_actions.duplicate'),
      iconLeft: 'copy' as IconName,
      id: BillsTableStaticActionType.Duplicate,
      value: BillsTableStaticActionType.Duplicate,
      to: duplicateBillUrl,
    },
  ]

  if (!isDraft) {
    items.push({
      children: t('bills.table.static_actions.credit'),
      iconLeft: 'fileSpreadsheet' as IconName,
      id: BillsTableStaticActionType.Credit,
      value: BillsTableStaticActionType.Credit,
      to: createCreditNoteUrl,
    })
  }

  if (canRegisterPayment) {
    items.unshift({
      children: t('bills.table.static_actions.register_payment'),
      iconLeft: 'handCoins' as IconName,
      id: BillsTableStaticActionType.RegisterPayment,
      value: BillsTableStaticActionType.RegisterPayment,
    })
  }

  if (isCashBasedAndPaid) {
    items.push({
      children: t('bills.table.static_actions.void_payment'),
      iconLeft: 'banknoteX' as IconName,
      id: BillsTableStaticActionType.VoidPayment,
      value: BillsTableStaticActionType.VoidPayment,
    })
  }

  if (hasIntegrationSync) {
    items.push({
      children: t('bill.action.retry_sync'),
      iconLeft: 'refresh' as IconName,
      id: BillsTableStaticActionType.RetrySync,
      value: BillsTableStaticActionType.RetrySync,
      readonly: !isSyncRetryable,
    })
  }

  items.push({
    children: (
      <VoidStaticActionButton
        isSyncedWithCPA={hasIntegrationSync}
        toolTipMessage={t('bills.table.static_actions.tooltip.sync_cpa')}
      />
    ),
    iconLeft: 'circleX' as IconName,
    id: isDraft ? BillsTableStaticActionType.Delete : BillsTableStaticActionType.Void,
    value: isDraft ? BillsTableStaticActionType.Delete : BillsTableStaticActionType.Void,
    readonly: hasIntegrationSync,
  })

  return items
}
